import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { class: "p-mx-2" }
const _hoisted_3 = { class: "p-inputgroup" }
const _hoisted_4 = { class: "p-mt-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "p-text-center p-p-3" }, "No records found", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h4", null, "Please choose any of the action below :", -1)
const _hoisted_7 = { class: "p-grid" }
const _hoisted_8 = { class: "p-col" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h4", { class: "p-dialog-titlebar p-dialog-titlebar-icon" }, " Supplier Credit History ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "p-text-center p-p-3" }, "No records found", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Toolbar, null, {
        start: _withCtx(() => [
          _createVNode(_component_Breadcrumb, {
            home: _ctx.home,
            model: _ctx.items,
            class: "p-menuitem-text"
          }, null, 8, ["home", "model"])
        ]),
        end: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_InputText, {
                modelValue: _ctx.keyword,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.keyword) = $event)),
                modelModifiers: { trim: true },
                placeholder: "Contact No"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_Button, {
                icon: "pi pi-search ",
                class: "p-button-primary p-mr-1",
                onClick: _ctx.loadSearchData
              }, null, 8, ["onClick"]),
              _createVNode(_component_Button, {
                icon: "pi pi-times ",
                class: "p-button-info p-mr-1",
                onClick: _ctx.cleanSearchData
              }, null, 8, ["onClick"])
            ])
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_DataTable, {
          first: _ctx.goToFirstLink,
          "onUpdate:first": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.goToFirstLink) = $event)),
          firstModifiers: { sync: true },
          value: _ctx.lists,
          lazy: true,
          paginator: _ctx.checkPagination,
          rows: _ctx.limit,
          totalRecords: _ctx.totalRecords,
          scrollable: true,
          onPage: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onPage($event))),
          class: "p-datatable-sm p-datatable-striped p-datatable-gridlines"
        }, {
          empty: _withCtx(() => [
            _hoisted_5
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              field: "account_title",
              header: " Profile Name"
            }),
            _createVNode(_component_Column, {
              field: "email_address",
              header: "Email Address"
            }),
            _createVNode(_component_Column, {
              field: "contact_no",
              header: "Contact No"
            }),
            _createVNode(_component_Column, {
              field: "company",
              header: "Company"
            }),
            _createVNode(_component_Column, {
              field: "supplier_receivable",
              header: "Payable"
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(_ctx.currency) + " " + _toDisplayString(slotProps.data.supplier_receivable), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "supplier_payable",
              header: "Receivable"
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(_ctx.currency) + " " + _toDisplayString(slotProps.data.supplier_payable), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              exportable: false,
              header: "Action"
            }, {
              body: _withCtx((slotProps) => [
                _createVNode(_component_Button, {
                  icon: "pi pi-cog",
                  class: "p-button-primary",
                  hidden: slotProps.data.sessionEndedAt,
                  onClick: ($event: any) => (_ctx.openMenu(slotProps.data))
                }, null, 8, ["hidden", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["first", "value", "paginator", "rows", "totalRecords"])
      ]),
      _createVNode(_component_Sidebar, {
        visible: _ctx.menuBar,
        "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.menuBar) = $event)),
        position: "bottom",
        class: "p-sidebar-sm"
      }, {
        default: _withCtx(() => [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_Button, {
                icon: "pi pi-doller",
                label: "Show History",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.viewHistory())),
                class: "p-button-primary p-button-md p-mx-2"
              }),
              _createVNode(_component_Button, {
                icon: "pi pi-doller",
                label: "Show Transactions",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.viewTransactions())),
                class: "p-button-primary p-button-md p-mx-2"
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_Dialog, {
        visible: _ctx.receipts,
        "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.receipts) = $event)),
        style: { width: '100vw' },
        position: "top",
        class: "p-fluid p-m-0 p-dialog-maximized"
      }, {
        header: _withCtx(() => [
          _hoisted_9
        ]),
        default: _withCtx(() => [
          _createVNode(_component_DataTable, {
            first: _ctx.goToSubFirstLink,
            "onUpdate:first": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.goToSubFirstLink) = $event)),
            firstModifiers: { sync: true },
            value: _ctx.supplierReceipts,
            lazy: true,
            paginator: _ctx.checkSubPagination,
            rows: _ctx.limit,
            totalRecords: _ctx.totalSubRecords,
            scrollable: true,
            onPage: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onSubPage($event))),
            class: "p-datatable-sm p-datatable-striped p-datatable-gridlines"
          }, {
            empty: _withCtx(() => [
              _hoisted_10
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                field: "receipt_payment.receipt_no",
                header: "Receipt No"
              }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString((slotProps.data.receipt_payment)? slotProps.data.receipt_payment.receipt_no : slotProps.data.pay_later.receipt_no), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Trans Amount" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(_ctx.currency) + " " + _toDisplayString(Number(slotProps.data.amount).toFixed(2)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "type_id",
                header: "Transaction Type"
              }),
              _createVNode(_component_Column, {
                field: "created_at",
                header: "Transaction At"
              }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(_ctx.formatDateTime(slotProps.data.created_at)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "new_supplier_receivable",
                header: "Total Payables"
              }),
              _createVNode(_component_Column, {
                field: "new_supplier_payable",
                header: "Total Receivables"
              })
            ]),
            _: 1
          }, 8, ["first", "value", "paginator", "rows", "totalRecords"])
        ]),
        _: 1
      }, 8, ["visible"])
    ])
  ]))
}